<div id="crm-team-member-form" *ngIf="readOnly; else formField">
  <div class="crm-field-label">{{ 'CRM.CUSTOM_INPUT.OWNER' | translate }}</div>
  <div class="crm-field-value">
    <!-- ng-container necessary since Angular interpolation will add empty space -->
    <ng-container *ngIf="teamMemberName() as teamMemberName; else loading">
      <ng-container *ngIf="teamMemberName !== NO_VALUE_FOR_TEAM_MEMBER">
        {{ teamMemberName }}
      </ng-container>
    </ng-container>
    <ng-template #loading>
      <div class="stencil-shimmer"></div>
    </ng-template>
  </div>
</div>
<ng-template #formField>
  <glxy-form-field *ngIf="!loadingValues(); else loadingField">
    <glxy-label>{{ 'CRM.CUSTOM_INPUT.OWNER' | translate }}</glxy-label>
    <input
      #input
      type="text"
      matInput
      [formControl]="_control"
      [matAutocomplete]="auto"
      data-testid="form-owner-input"
      [placeholder]="'TABLE_FILTERS.SELECT_EXPRESSION_PLACEHOLDER' | translate"
      (blur)="saveField()"
      (keydown.enter)="$event.preventDefault()"
      (input)="filter()"
      (focus)="filter()"
    />
    @if (control.value) {
      <button matSuffix mat-icon-button class="crm-field-clear-button" aria-label="Clear" (click)="clear()">
        <mat-icon>close</mat-icon>
      </button>
    }
    <mat-autocomplete
      requireSelection
      autoActiveFirstOption
      #auto="matAutocomplete"
      [displayWith]="displayFn(availableOptions())"
    >
      @for (option of filteredOptions(); track option) {
        <mat-option [value]="option" (mousedown)="$event.preventDefault()">{{ option?.displayName }}</mat-option>
      }
    </mat-autocomplete>
    @if (formGroup.errors?.ownerIsInAdditionalTeamMembers) {
      <glxy-error>
        {{ 'CRM.FORMS.OWNER_IN_ADDITIONAL_TEAM_MEMBERS' | translate }}
      </glxy-error>
    }
  </glxy-form-field>
  <ng-template #loadingField>
    <glxy-form-field>
      <glxy-label>{{ 'CRM.CUSTOM_INPUT.OWNER' | translate }}</glxy-label>
      <input type="text" disabled matInput />
      <mat-spinner matPrefix diameter="24"></mat-spinner>
    </glxy-form-field>
  </ng-template>
</ng-template>
